import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
    unreadCount: 0,
    notificationNavigation: {
      showFeedbackModal: false,
    },
  },
  reducers: {
    setNotifications: (state, { payload }) => {
      state.list = payload;
      state.unreadCount = payload.filter((n) => !n.IsSeen).length;
    },

    addNotification: (state, { payload }) => {
      // Prepend real-time notification so newest is first
      state.list = [payload, ...state.list];
      state.unreadCount += 1;
    },

    showFeedbackModal: (state, { payload }) => {
      state.notificationNavigation.showFeedbackModal = payload;
    },

    markAllRead: (state) => {
      state.list = state.list.map((n) => ({ ...n, IsSeen: 1 }));
      state.unreadCount = 0;
    },

    markOneRead: (state, { payload: { notificationId, isSeen = true } }) => {
      state.list = state.list.map((n) =>
        n.NotificationId === notificationId
          ? { ...n, IsSeen: isSeen ? 1 : 0 }
          : n,
      );
      state.unreadCount = state.list.filter((n) => !n.IsSeen).length;
    },
  },
});

export const {
  setNotifications,
  addNotification,
  markAllRead,
  markOneRead,
  showFeedbackModal,
} = notificationSlice.actions;

export default notificationSlice.reducer;
